(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (!this.header) return;

      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = this.header.getBoundingClientRect();
      this.currentScrollTop = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
      this.preventReveal = false;
      this.scrollFrame = 0;
      this.isScrolling = 0;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.queueScroll.bind(this);
      this.onResizeHandler = this.setHeaderHeight.bind(this);
      this.onPageShowHandler = this.handlePageShow.bind(this);
      this.hideHeaderOnScrollUp = () => { this.preventReveal = true; };

      this.setHeaderHeight();

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.onResizeHandler);
        this.resizeObserver.observe(this.header);
      } else {
        window.addEventListener('resize', this.onResizeHandler, { passive: true });
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('pageshow', this.onPageShowHandler, { passive: true });

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('pageshow', this.onPageShowHandler);
      window.removeEventListener('resize', this.onResizeHandler);
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.boundsObserver) this.boundsObserver.disconnect();
      if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
      if (this.isScrolling) window.clearTimeout(this.isScrolling);
    }

    setHeaderHeight() {
      if (!this.header || !this.header.isConnected) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    createObserver() {
      if (!('IntersectionObserver' in window)) {
        this.headerBounds = this.header.getBoundingClientRect();
        return;
      }

      this.boundsObserver = new IntersectionObserver((entries, observer) => {
        if (entries[0]) this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
        this.boundsObserver = null;
      });

      this.boundsObserver.observe(this.header);
    }

    queueScroll() {
      if (this.scrollFrame) return;
      this.scrollFrame = requestAnimationFrame(() => {
        this.scrollFrame = 0;
        this.onScroll();
      });
    }

    onScroll() {
      const scrollTop = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) {
        this.currentScrollTop = scrollTop;
        return;
      }

      const boundsBottom = Number.isFinite(this.headerBounds?.bottom) ? this.headerBounds.bottom : this.header.offsetHeight;
      const boundsTop = Number.isFinite(this.headerBounds?.top) ? this.headerBounds.top : 0;

      if (scrollTop > this.currentScrollTop && scrollTop > boundsBottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventHide) this.hide();
      } else if (scrollTop < this.currentScrollTop && scrollTop > boundsBottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          this.reveal();
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = window.setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          this.hide();
        }
      } else if (scrollTop <= boundsTop) {
        this.header.classList.remove('scrolled-past-header');
        this.reset();
      }

      this.currentScrollTop = scrollTop;
    }

    handlePageShow() {
      this.currentScrollTop = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
      this.setHeaderHeight();
      this.createObserver();
      this.queueScroll();
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') this.searchModal.close(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  class StaticHeader extends HTMLElement {
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (!this.header) return;
      this.onResizeHandler = this.setHeaderHeight.bind(this);
      this.setHeaderHeight();

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.onResizeHandler);
        this.resizeObserver.observe(this.header);
      } else {
        window.addEventListener('resize', this.onResizeHandler, { passive: true });
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResizeHandler);
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    setHeaderHeight() {
      if (!this.header || !this.header.isConnected) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  if (!customElements.get('static-header')) {
    customElements.define('static-header', StaticHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
